import { ValidatorFn } from "@angular/forms";
import { isNil } from "lodash-es";

export function makeValidatorOptional<
  E extends [name: string, error: { actual: unknown }],
>(
  isValueCorrect: (value: unknown) => value is E[1]["actual"],
  baseValidator: (value: E[1]["actual"]) => ValidatorResult<E>,
): ValidatorFn {
  return (control) => {
    if (isEmptyValue(control.value)) {
      return null;
    } else if (!isValueCorrect(control.value)) {
      throw new Error(`Unexpected control value: ${String(control.value)}`);
    } else {
      return baseValidator(control.value);
    }
  };
}

// Validator error types for Angular's build in `Validators` validators. We can
//  use these in our own validators for consistency in error messaging.
export type EmailValidatorError = ["email", true];

// Empty values should be allowed for most all validators.
// The `required` validator can be added to handle the empty case, if needed.
export function isEmptyValue(value: unknown): value is null | undefined | "" {
  return isNil(value) || value === "";
}

type ErrorObject<T extends [name: string, error: unknown]> = {
  [K in T[0]]: T[1];
};

export type ValidatorResult<T extends [name: string, error: unknown]> =
  ErrorObject<T> | null;
